/* eslint-disable */
import React, { useState, createContext } from 'react'
import { ACCOUNTS_PAGE_HEADER } from 'AccountsConstants/language/account'
import {
  httpAxios,
  checkUserLogin,
  checkMobileDevice,
  populateTripResponse,
  getTripIdForApp,
  isTripDetailsPage,
  getCommonClevertapParams,
  triggerClevertap,
  convertToSafariCompatibleDate,
  readCookie,
  isInvalidTripId,
  addClassToId,
  removeClassFromId,
  getPageCount,
  makeArrayUnique,
  removeSpacesAndCapitalize,
  getAmendmentLink,
  getCancellationLink,
  appJSCallBack,
  isAndroidApp,
  isIosApp,
  navigateToExternalLink,
  getQueryParams
} from 'AccountsUtils'
import {
  SIGN_IN_CHECK_URL,
  GET_CALL,
  POST_CALL,
  TRIP_SUPPORT_NUMBER
} from 'AccountsConstants/api_endpoints'

import { UNAUTHORIZED_REDIRECT } from 'AccountsConstants/routes'
import { getAuthenticated } from '../pages/Trips/trips.helper'

export const AccountsContext = createContext({
  ticketed: false,
  updateTicketed: () => {},
  currentBookingStatus: '',
  setCurrentBookingStatus: () => {},
  travellerLastName: '',
  updateTravellerLastName: () => {},
  accountsHeader: '',
  accountsSubHeader: '',
  showBackButton: false,
  handleAccountsHeaderChange: () => {},
  handleUpdateBackButton: () => {},
  accountsLoading: false,
  accountsLoadingHandler: false,
  trips: [],
  selectedTrip: {},
  fetchTripList: () => {},
  updateSelectedTrip: () => {},
  checkSignIn: () => {},
  openModal: () => {},
  closeModal: () => {},
  isModalOpen: false,
  isLoggedIn: false,
  isPWA: false,
  loading: false,
  loadingFailed: false,
  loadingHandler: () => {},
  loadingFailedHandler: () => {},
  upcomingTripsCount: 0,
  upcomingTripsCountHandler: () => {},
  tripListAPIData: {},
  updateTripListAPIData: () => {},
  pageData: {},
  setDataHandler: () => {},
  showLoadMore: false,
  expiredTripsCount: 0,
  archivedTripsCount: 0,
  classesAddedToWidgetContainer: '',
  updateWidgetContainerClasses: () => {},
  showCallingNumberModal: false,
  updateCallingNumberFlag: () => {},
  tripOptionsData: {},
  isTripOptionsNew:false,
  updateTripOptions: () => {},
  tripOptionsAPIData: {},
  updateTripOptionsAPIData: () => {},
  showTripList: () => {},
  updateShowFlagForTripList: () => {},
  selectedIssue: false,
  updateSelectedIssue: () => {},
  selectedSubIssue: false,
  updateSelectedSubIssue: () => {},
  previousStepOptionsData: {},
  updatePreviousOptions: () => {},
  showSupportNumbers: false,
  updateFlagToShowSupportNumbers: () => {},
  showCallbackModal: false,
  updateFlagToShowCallbackModal: () => {},
  showFulfillmentMessage: false,
  updateFlagToShowFulfillmentMessage: () => {},
  initialList: {},
  initialNewTreeData:{},
  populateInitialList: () => {},
  updatePreviousOptionsAPIData: () => {},
  previousOptionsAPIData: {},
  callbackRequestData: {},
  updateCallbackRequestData: () => {},
  callbackOptionsData: {},
  updateCallbackOptions: () => {},
  setIsPWA: () => {},
  shouldCloseModal: false,
  updateShouldCloseFlag: () => {},
  callbackLoader: false,
  modalMessage: '',
  detailsPageInvalid: false,
})

export const AccountsState = ({ children }) => {
  const [hifiveStates, setHifiveStates] = useState({})
  const [accountsHeader, setAccountsHeader] = useState(ACCOUNTS_PAGE_HEADER)
  const [accountsSubHeader, setAccounsSubHeader] = useState('')
  const handleAccountsHeaderChange = value => {
    setAccountsHeader(value.header)
    setAccounsSubHeader(value.subHeader)
  }
  const [showBackButton, updateBackButton] = useState(false)
  const handleUpdateBackButton = value => {
    updateBackButton(value)
  }
  /*States used in the context*/
  const [isModalOpen, toggleModal] = useState(false)
  const [travellerLastName, updateTravellerLastName] = useState('')
  const [ticketed, updateTicketed] = useState(false)
  const [currentBookingStatus, setCurrentBookingStatus] = useState(false)

  const [isPWA, setIsPWA] = useState(false)
  const [loading, loadingHandler] = useState(false)
  const [loadingFailed, loadingFailedHandler] = useState(false)
  const [initialList, populateInitialList] = useState(true)
  const [initialNewTreeData, setInitialNewTreeData] = useState(null)
  
  const [isLoggedIn, updateLogin] = useState(false)
  const [trips, fetchTripList] = useState([])
  const [selectedTrip, updateSelectedTrip] = useState({})
  const [selectedIssue, updateSelectedIssue] = useState({ visible: false })
  const [selectedSubIssue, updateSelectedSubIssue] = useState({})
  const [upcomingTripsCount, upcomingTripsCountHandler] = useState(0)
  const [tripListAPIData, updateTripListAPIData] = useState({})
  const [tripOptionsData, updateTripOptions] = useState({})
  const [isTripOptionsNew, setIsTripOptionsNew] = useState(true)
  const [supportHeader, setSupportHeader] = useState(null)
  const [supportInputType, setSupportInputType] = useState(null)
  const [airlineInfo, setAirlineInfo] = useState(null)
  const [previousStepOptionsData, updatePreviousOptions] = useState({})
  const [tripOptionsAPIData, updateTripOptionsAPIData] = useState({})
  const [previousOptionsAPIData, updatePreviousOptionsAPIData] = useState({})

  const [pageData, setDataHandler] = useState({ page: 0 })
  const [showLoadMore, showLoadMoreHandler] = useState(true)
  const [expiredTripsCount, updateExpiredTripsCount] = useState(0)
  const [archivedTripsCount, updateArchivedTripsCount] = useState(0)
  const [customerCareNumber, updateCustomerSupportNumber] = useState(0)
  const [
    classesAddedToWidgetContainer,
    updateWidgetContainerClasses
  ] = useState('support-widget-container')
  const [showCallingNumberModal, updateCallingNumberFlag] = useState(false)
  const [showTripList, updateShowFlagForTripList] = useState(true)
  const [showFulfillmentMessage, updateFlagToShowFulfillmentMessage] = useState(
    false
  )

  const [showSupportNumbers, updateFlagToShowSupportNumbers] = useState(false)
  const [showCallbackModal, updateFlagToShowCallbackModal] = useState(false)
  const [callbackRequestData, updateCallbackRequestData] = useState({})
  const [callbackOptionsData, updateCallbackOptions] = useState({})
  const [shouldCloseModal, updateShouldCloseFlag] = useState(false)
  const [callbackLoader, updateCallbackLoader] = useState(false)
  const [isShowLoadMore, updateShowLoadMore] = useState(true)
  const [modalMessage, updateModalMessage] = useState('')
  const [modalTitle, updateModalTitle] = useState('')
  const [detailsPageInvalid, updateInvalidDetailsPageHandler] = useState(false)
  const [previousSettingsFlag, updatePreviousSettings] = useState(false)
  // *********Support States **************************

  const [accountsLoading, accountsLoadingHandler] = useState(false)

  const [isVerified, updateIsVerfiedFlag] = useState(false)
  const [emailSent, updateEmailSentFlag] = useState(false)
  const [showWidget, updateShowWidget] = useState(false)
  const params = getQueryParams()
  const checkVerification = () => {
    loadingHandler(true)
    let emailFromCookie = decodeURIComponent(readCookie('userid'))
    emailFromCookie = emailFromCookie.split('|')
    emailFromCookie =
      emailFromCookie && emailFromCookie.length && emailFromCookie !== 'null'
        ? emailFromCookie[0]
        : ''
    const param = {
      email: emailFromCookie
    }
    if (emailFromCookie) {
      httpAxios('/account/verify/status', GET_CALL, param)
        .then(res => {
          loadingHandler(false)
          if (res && res.data) {
            updateIsVerfiedFlag(res.data.isVerified)
            updateShowWidget(res.data.showWidget)
          }
        })
        .catch(err => {
          loadingHandler(false)
        })
    } else {
      updateIsVerfiedFlag(false)
    }
  }
  
  const verifyEmail = () => {
    loadingHandler(true)
    let emailFromCookie = decodeURIComponent(readCookie('userid'))
    emailFromCookie = emailFromCookie.split('|')
    emailFromCookie =
      emailFromCookie && emailFromCookie.length && emailFromCookie !== 'null'
        ? emailFromCookie[0]
        : ''
    const param = {
      username: emailFromCookie
    }
    httpAxios('/account/verify/email', GET_CALL, param)
      .then(res => {
        loadingHandler(false)
        updateEmailSentFlag(true)
      })
      .catch(err => {
        loadingHandler(false)
      })
  }

  const checkSignIn = () => {
    if (checkUserLogin()) {
      accountsLoadingHandler(false)
      updateLogin(true)
    } else {
      accountsLoadingHandler(true)
      httpAxios(SIGN_IN_CHECK_URL, GET_CALL, '')
        .then(res => {
          accountsLoadingHandler(false)
          updateLogin(true)
        })
        .catch(err => {
          accountsLoadingHandler(false)
          updateLogin(false)
        })
    }
  }

  const closeModal = () => {
    removeClassFromId('body', 'pushOverlay')
    toggleModal(false)
    setDataHandler({ page: 0 })
    updateTripListAPIData({
      ...tripListAPIData,
      pageNo: 0,
      firstCall: true,
      tripStatus: '"upcoming"'
    })
    updateSelectedIssue(false)
    if (isTripDetailsPage()) {
      updateShowFlagForTripList(false)
      updateTripOptions(initialList)
      const payload = {
        tripId: getTripIdForApp(),
        level: 'L1'
      }
      updateTripOptionsAPIData(payload)
    } else {
      updateShowLoadMore(true)
      updateShowFlagForTripList(true)
    }
    appJSCallBack('onChatCloseClicked')
    if (checkMobileDevice()) {
      if (isAndroidApp() && window.mobileChat) {
        window.mobileChat.onChatCloseClicked()
      } else if (isIosApp()) {
        window.location.href = 'ioscleartrip://onChatCloseClicked(nochange)'
      }
    }
  }

  const [callingNumberCallStarted, updateCallingNumberCall] = useState(false)
  const fetchCallingNumber = () => {
    if (callingNumberCallStarted) {
      return
    }
    updateCallingNumberCall(true)
    const filteredDomain = window.location.hostname.replace(/www.|qa2./, '')
    const params = {
      domain: filteredDomain,
      site_language: window.location.href.indexOf('/ar/') > -1 ? 'ar' : ''
    }
    httpAxios(TRIP_SUPPORT_NUMBER, GET_CALL, params)
      .then(res => {
        if (typeof res === 'string') {
          updateCustomerSupportNumber(res)
        } else {
          updateCustomerSupportNumber(res.data.supportNumber)
        }
        updateCallingNumberCall(false)
      })
      .catch(err => {
        // if (err && err.response && err.response.status === 503) {
        //   updateShouldCloseFlag(true)
        // }
      })
  }
  /*
    fetch trip list, based on
    dbFetchType: "REAL_TIME"
    firstCall: false
    pageNo: 1
    pageSize: 5 -> set in constants
    tripStatus: "expired" -> can be upcoming/ expired or archived
                             first all upcoming and first 5 expired are fetched
                             and then paginated
    userId: null -> required on trip service end, can be derived from cookie if need be
                    was not available for customers logged in from a very long time and
                    hence is handled from selfcare end
  */

  async function getAuthenticatedApiResponse() {
    const resp = await getAuthenticated()
    const { status } = resp
    return status
  }

  const checkAuthorization = () => {
    
     const statusToGetAuthenticated = getAuthenticatedApiResponse()
     console.log("check here", statusToGetAuthenticated)
    return (  checkUserLogin()  && statusToGetAuthenticated === 200)
  }

  const fetchAllTrips = apiData => {
    if (!apiData || !Object.keys(apiData).length) {
      return
    }
    loadingFailedHandler(false)
    loadingHandler(true)
    if (checkUserLogin()) {
      httpAxios('/communication/selfcare/api/tripList', POST_CALL, apiData)
        .then(res => {
          updateShowLoadMore(true)
          const { data } = res
          if (data.upcomingTrips && data.expiredTrips) {
            let optTrips = []
            let expiredTrips = []
            loadingHandler(false)
            loadingFailedHandler(false)
            if (apiData.firstCall) {
              optTrips = populateTripResponse(data, 'upcomingTrips')
              expiredTrips = populateTripResponse(data, 'expiredTrips')
              const clevertapData = getCommonClevertapParams()
              if (optTrips.length) {
                upcomingTripsCountHandler(optTrips.length)
                clevertapData.list_shown = 'Yes'
                updateTripListAPIData({
                  pageSize: 10,
                  pageNo: 0,
                  firstCall: false,
                  tripStatus: 'expiredCompleted'
                })
                setDataHandler({ page: apiData.pageNo + 1 })
              } else if (optTrips.length === 0) {
                clevertapData.list_shown = 'Yes, 0 trips'
                loadingHandler(true)
                updateTripListAPIData({
                  pageNo: 0,
                  pageSize: 10,
                  firstCall: false,
                  tripStatus: 'expiredCompleted'
                })
                fetchAllTrips({
                  pageNo: 0,
                  pageSize: 10,
                  firstCall: false,
                  tripStatus: 'expiredCompleted'
                })
              } else {
                clevertapData.list_shown = 'No'
              }
              clevertapData.event_type = 'support_trip_list_shown'
              triggerClevertap('Account', clevertapData)
              optTrips.sort((trip1, trip2) => {
                const t1 = new Date(
                  convertToSafariCompatibleDate(trip1.travelDate)
                )
                const t2 = new Date(
                  convertToSafariCompatibleDate(trip2.travelDate)
                )
                return t1 - t2
              })
              fetchTripList([...optTrips, ...expiredTrips])
            } else {
              const { page } = pageData
              setDataHandler({ page: page + 1 })
              expiredTrips = populateTripResponse(data, 'expiredTrips') || []
              optTrips = populateTripResponse(data, 'archivedTrips') || []
              if (expiredTrips.length) {
                updateExpiredTripsCount(data.expiredTrips.totalElements)
                const tripsData = [...trips, ...expiredTrips]
                fetchTripList(makeArrayUnique(tripsData, 'tripId'))
              } else if (optTrips.length) {
                if (apiData.pageNo === 0) {
                  updateArchivedTripsCount(data.archivedTrips.totalElements)
                }
                fetchTripList([...trips, ...optTrips])
              } else {
                updateShowLoadMore(false)
              }
              // apidata is updated for next page load so pageno inceremented with 1
              if (
                apiData.pageNo + 1 >=
                  getPageCount(
                    data.expiredTrips.totalElements,
                    apiData.pageSize
                  ) &&
                apiData.pageNo > 1
              ) {
                updateTripListAPIData({
                  pageNo: 0,
                  pageSize: 10,
                  firstCall: false,
                  tripStatus: 'archived'
                })
                setDataHandler({ page: 1 })
              } else {
                if (Object.keys(tripListAPIData).length) {
                  updateTripListAPIData({
                    ...apiData,
                    pageNo: tripListAPIData.pageNo + 1
                  })
                } else {
                  updateTripListAPIData({
                    ...apiData,
                    pageNo: 1
                  })
                }
              }
            }
            showLoadMoreHandler(isShowLoadMore)
          } else {
            loadingHandler(false)
            loadingFailedHandler(true)
          }
        })
        .catch(err => {
          loadingHandler(false)
          loadingFailedHandler(true)
          if (apiData.firstCall) {
            const clevertapData = getCommonClevertapParams()
            clevertapData.list_shown = 'No'
            clevertapData.event_type = 'support_trip_list_shown'
            triggerClevertap('Account', clevertapData)
          }
          updateShouldCloseFlag(true)
        })
    } else {
      navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
    }
  }

  const openModal = () => {
    addClassToId('body', 'pushOverlay')
    const clevertapData = { ...getCommonClevertapParams() }
    clevertapData.event_type = 'support_button_clicked'
    triggerClevertap('Account', clevertapData)
    toggleModal(true)
    if (!isTripDetailsPage()) {
      const payload = {
        firstCall: true,
        pageSize: 5,
        pageNo: 0,
        tripStatus: 'upcoming'
      }
      updateTripListAPIData(payload)
      fetchAllTrips(payload)
      updateShowLoadMore(true)
    }
  }

  const [detailsCallStarted, updateDetailsCallStart] = useState(false)
  const [optionCallStarted, updateOptionCallStart] = useState(false)

  const getOptionsfromList = list => {
    let opts = []
    if (list && list.length) {
      opts = list.map(opt => {
        return opt.value
      })
    }
    opts = opts.join('|')
    return opts
  }

  const fetchOptions = async (obj,flag,submit,cb={}) => {
    if(flag){
      let apidata={}
      if(submit){
        apidata={
          tripId:selectedTrip.tripId || obj.tripId,
          menuClicked:null,
          buttonClicked:obj.buttonClicked,
          menusClickedHistory:obj.menusClickedHistory || [],
          additionalParams:obj.additionalParams||null
        }
      }else{
        apidata={
           tripId:selectedTrip.tripId || obj.tripId,
           menuClicked:obj.menuClicked || "root",
           menusClickedHistory:obj.menusClickedHistory || [],
           additionalParams:obj.additionalParams||null
         }
      }
      await httpAxios(
        `/communication/selfcare/api/supportV2/${obj.tripId}`,
        POST_CALL,
        apidata
      ).then(res=>{
        cb(res.data)
      }).catch(err=>{
        cb(err)
      })
    }
    else if(!flag){
      showLoadMoreHandler(false)
      loadingHandler(true)
      loadingFailedHandler(false)
      // updateTripOptions({})
      let apiData = tripOptionsAPIData
      if (obj) {
        apiData = obj
      }
      if (optionCallStarted) {
        return
      }
      if (
        (apiData.mobile || apiData.email || apiData.complaint) &&
        apiData[`l${parseInt(apiData.level.charAt(1), 10) - 1}`] === 'callback'
      ) {
        updateCallbackLoader(true)
      }
      updateOptionCallStart(true)
      if (
        apiData.l1 &&
        apiData.l1 === 'Cancellation charges' &&
        apiData.level === 'L4' &&
        apiData.params &&
        apiData.l2
      ) {
        apiData.params.reason = removeSpacesAndCapitalize(apiData.l2)
      }
  
      if (
        apiData.l1 &&
        apiData.l1.toLowerCase() === 'modify booking' &&
        apiData.l2 &&
        apiData.l2.toLowerCase() ===
          'change flight or travel date for one/all pax' &&
        apiData.level === 'L3' &&
        selectedTrip.bookingType === 'D'
      ) {
        const link = getAmendmentLink(
          selectedTrip.tripOptions.newAmendFlow,
          selectedTrip.tripId
        )
        window.location.href = `${window.location.origin}${link}`
        return
      }
      let redirectMap = {}
      if (selectedTrip && selectedTrip.tripOptions && selectedTrip.tripId) {
        redirectMap = {
          amendTool: getAmendmentLink(
            selectedTrip.tripOptions.newAmendFlow,
            selectedTrip.tripId,
            params
          ),
          cancelTool: getCancellationLink(obj.tripId, params)
        }
      }
      httpAxios(
        `/communication/selfcare/api/support/${obj.tripId}`,
        POST_CALL,
        apiData
      )
        .then(res => {
          updateModalMessage('')
          let tripOptions = res.data
          if (res && res.data) {
            setSupportHeader(res.data.header)
            setSupportInputType(res.data.inputType)
            setAirlineInfo(res.data.airlineInfo)
          }
          if (
            tripOptions &&
            tripOptions.type &&
            tripOptions.type.toLowerCase() === 'redirect' &&
            (tripOptions.redirectTo !== null &&
              tripOptions.redirectTo !== undefined &&
              tripOptions.redirectTo !== '')
          ) {
            const href =
              redirectMap &&
              tripOptions.redirectTo &&
              redirectMap[tripOptions.redirectTo]
                ? redirectMap[tripOptions.redirectTo]
                : null
            if (href) {
              window.location.href = `${window.location.origin}${href}`
            }
          } else {
            if (res.data && res.data.body) {
              tripOptions = res.data.body
            }
            updateCallbackLoader(false)
            loadingHandler(false)
            loadingFailedHandler(false)
            if (
              tripOptions &&
              (!tripOptions.supportDisplayOptions ||
                !tripOptions.supportDisplayOptions.length)
            ) {
              tripOptions.supportDisplayOptions = []
            }
            if (
              apiData.level !== 'L1' &&
              ['menu', 'action'].indexOf(tripOptionsData.type) > -1
            ) {
              const prev = { ...previousStepOptionsData }
              prev[apiData.level] = tripOptionsData
              updatePreviousOptions(prev)
              tripOptions.supportDisplayOptions.push({
                value: 'Take me back to the previous menu',
                type: 'back'
              })
            } else {
              populateInitialList(tripOptions)
            }
            const clevertapData = getCommonClevertapParams()
            clevertapData.trip_ID = selectedTrip.tripId
            clevertapData.trip_status = selectedTrip.bookingStatus
            clevertapData.event_type = 'support_issue_list_shown'
            if (
              tripOptions.type === 'menu' ||
              tripOptions.type === 'action' ||
              tripOptions.type === 'airlineInfo'
            ) {
              updateTripOptions(tripOptions)
              clevertapData.option_list = getOptionsfromList(
                tripOptions.supportDisplayOptions
              )
              clevertapData.trip_ID = selectedTrip.tripId
              clevertapData.trip_status = selectedTrip.bookingStatus
              clevertapData.product = selectedTrip.verticalName
            } else if (tripOptions.type === 'callback') {
              updateModalMessage(tripOptions.message)
              updateCallbackRequestData({ ...tripOptionsAPIData })
              updateCallbackOptions({ ...tripOptions })
              updateFlagToShowCallbackModal(true)
              updateWidgetContainerClasses(
                'support-widget-container push-left alertOverlay'
              )
              clevertapData.event_type = 'support_callback_widget_shown'
              updatePreviousSettings(true)
            } else if (tripOptions.type === 'complaint') {
              updateModalMessage(tripOptions.message)
              updateCallbackRequestData({ ...tripOptionsAPIData })
              updateCallbackOptions({ ...tripOptions })
              updateFlagToShowCallbackModal(true)
              updateWidgetContainerClasses(
                'support-widget-container push-left alertOverlay'
              )
              clevertapData.event_type = 'support_callback_widget_shown'
              updatePreviousSettings(true)
            } else if (tripOptions.type === 'support') {
              if (apiData.level === 'L1') {
                updateShowFlagForTripList(true)
                showLoadMoreHandler(isShowLoadMore)
                if (isTripDetailsPage()) {
                  updateInvalidDetailsPageHandler(true)
                }
              }
              updateFlagToShowCallbackModal(false)
              updateFlagToShowFulfillmentMessage(false)
              updateFlagToShowSupportNumbers(true)
              updateWidgetContainerClasses(
                'support-widget-container push-left alertOverlay'
              )
              if (tripOptions.caseType && tripOptions.caseType === 'sos') {
                clevertapData.SOS_Trip = true
              }
              clevertapData.event_type = 'support_numbers_shown'
              updatePreviousSettings(true)
            } else if (tripOptions.type === 'fulfillment') {
              updateModalMessage(tripOptions.message)
              updateFlagToShowCallbackModal(false)
              updateFlagToShowFulfillmentMessage(true)
              updateWidgetContainerClasses(
                'support-widget-container push-left alertOverlay'
              )
              clevertapData.event_type = 'support_ff_widget_shown'
              updatePreviousSettings(true)
            } else if (tripOptions.type === 'outbound') {
              updateModalMessage(tripOptions.message)
              updateFlagToShowCallbackModal(false)
              updateFlagToShowFulfillmentMessage(true)
              updateWidgetContainerClasses(
                'support-widget-container push-left alertOverlay'
              )
              clevertapData.event_type = 'support_ff_widget_shown'
              updatePreviousSettings(true)
            } else if (tripOptions.type === 'info') {
              updateModalMessage(tripOptions.message)
              updateFlagToShowCallbackModal(false)
              updateFlagToShowFulfillmentMessage(false)
              updateInvalidDetailsPageHandler(true)
            } else if (tripOptions.type === 'messageBox') {
              updateModalMessage(tripOptions.infoMessages)
              updateModalTitle(tripOptions.title)
              updateFlagToShowCallbackModal(false)
              updateFlagToShowFulfillmentMessage(false)
              updateInvalidDetailsPageHandler(true)
            }
  
            if (tripOptions && tripOptions.caseType) {
              switch (tripOptions.caseType) {
                case 'escalation closed':
                  clevertapData.event_type =
                    'escalation_case_closed_message_shown'
                  break
                case 'escalation open':
                  clevertapData.event_type = 'escalation_case_open_message_shown'
                  break
                case 'resolving query':
                  clevertapData.event_type = 'within_SLA_message_shown'
                  break
                case 'case created':
                  clevertapData.event_type = 'query_success_message_shown'
                  break
                default:
                  break
              }
            }
            triggerClevertap('Account', clevertapData)
            updateOptionCallStart(false)
          }
        })
        .catch(err => {
          loadingHandler(false)
          updateModalMessage('')
          const clevertapData = getCommonClevertapParams()
          clevertapData.trip_ID = selectedTrip.tripId
          clevertapData.trip_status = selectedTrip.bookingStatus
          clevertapData.event_type = 'support_api_calls_failure'
          triggerClevertap('Account', clevertapData)
          loadingFailedHandler(true)
          updateOptionCallStart(false)
          if (err && err.response && err.response.status === 503) {
            updateShouldCloseFlag(true)
          }
        })
    }
    else{
      fetchOptions(obj)
    }
    
  }

  const fetchDetailsOfSelectedTrip = (param, payload) => {
    let id = getTripIdForApp()
    if (param) {
      id = param
    }
    if (isInvalidTripId(id)) {
      loadingHandler(false)
      loadingFailedHandler(true)
      updateShouldCloseFlag(true)
      return
    }
    loadingHandler(true)
    if (detailsCallStarted) {
      return
    }
    updateDetailsCallStart(true)
    // eslint-disable-next-line no-use-before-define
    // alert(`${window.location.origin}/communication/selfcare/api/tripDetails/${id}`)
    httpAxios(`/communication/selfcare/api/v2/tripDetails/${id}`, GET_CALL, '')
      .then(res => {
        const tripDetailsData = res.data
        loadingHandler(false)
        loadingFailedHandler(false)
        updateSelectedTrip(tripDetailsData)
        if(tripDetailsData.showNewTree) setIsTripOptionsNew(true)
        updateDetailsCallStart(false)
        const clevertapData = getCommonClevertapParams()
        clevertapData.trip_ID = tripDetailsData.tripId
        clevertapData.product = tripDetailsData.verticalName
        clevertapData.trip_status = tripDetailsData.bookingStatus
        clevertapData.event_type = 'support_issue_selection'
        triggerClevertap('Account', clevertapData)
        // if (tripDetailsData.verticalName !== 'air') {
        //   updateShouldCloseFlag(true)
        // }
        fetchOptions(payload)
        if(tripDetailsData.showNewTree){
          fetchOptions({
            tripId: tripDetailsData.tripId,
            menuClicked: '',
            menusClickedHistory: []
          },tripDetailsData.showNewTree,false,(res)=>{
              setInitialNewTreeData(res)
          })     
        }
      })
      .catch(err => {
        loadingHandler(false)
        loadingFailedHandler(true)
        updateDetailsCallStart(false)
        const clevertapData = getCommonClevertapParams()
        clevertapData.trip_ID = id
        clevertapData.error_code = err.status_code
        clevertapData.event_type = 'support_issue_selection'
        triggerClevertap('Account', clevertapData)
        updateShouldCloseFlag(true)
      })
  }

  return (
    <AccountsContext.Provider
      value={{
        hifiveStates, 
        setHifiveStates,
        accountsHeader,
        accountsSubHeader,
        handleAccountsHeaderChange,
        showBackButton,
        handleUpdateBackButton,
        isLoggedIn,
        checkSignIn,
        accountsLoading,
        trips,
        fetchAllTrips,
        selectedTrip,
        fetchTripList,
        updateSelectedTrip,
        isPWA,
        loading,
        loadingHandler,
        loadingFailed,
        loadingFailedHandler,
        upcomingTripsCount,
        upcomingTripsCountHandler,
        fetchDetailsOfSelectedTrip,
        tripListAPIData,
        updateTripListAPIData,
        pageData,
        setDataHandler,
        isModalOpen,
        openModal,
        closeModal,
        showLoadMore,
        expiredTripsCount,
        archivedTripsCount,
        customerCareNumber,
        airlineInfo,
        fetchCallingNumber,
        classesAddedToWidgetContainer,
        updateWidgetContainerClasses,
        showCallingNumberModal,
        updateCallingNumberFlag,
        tripOptionsAPIData,
        updateTripOptionsAPIData,
        updateTripOptions,
        tripOptionsData,
        isTripOptionsNew,
        fetchOptions,
        showTripList,
        updateShowFlagForTripList,
        selectedIssue,
        updateSelectedIssue,
        selectedSubIssue,
        updateSelectedSubIssue,
        previousStepOptionsData,
        updatePreviousOptions,
        showCallbackModal,
        showSupportNumbers,
        updateFlagToShowCallbackModal,
        updateFlagToShowSupportNumbers,
        showFulfillmentMessage,
        updateFlagToShowFulfillmentMessage,
        initialList,
        initialNewTreeData,
        populateInitialList,
        previousOptionsAPIData,
        updatePreviousOptionsAPIData,
        callbackRequestData,
        updateCallbackRequestData,
        updateCallbackOptions,
        callbackOptionsData,
        setIsPWA,
        shouldCloseModal,
        updateShouldCloseFlag,
        callbackLoader,
        modalMessage,
        detailsPageInvalid,
        travellerLastName,
        updateTravellerLastName,
        ticketed,
        updateTicketed,
        previousSettingsFlag,
        updatePreviousSettings,
        verifyEmail,
        isVerified,
        showWidget,
        currentBookingStatus,
        setCurrentBookingStatus,
        checkVerification,
        emailSent,
        supportHeader,
        supportInputType,
        updateEmailSentFlag,
        modalTitle,
      }}
    >
      {children}
    </AccountsContext.Provider>
  )
}
